module.exports = __webpack_public_path__ + "img/0Q3A6117_8_9_P_L_BlackMatted.ffffa130.jpg";